import { Component } from '@angular/core';
import {AuthenticationService} from '../../core/services/authentication.service';
import {JqueryCommonService} from '../../shared/services/jquery-common.service';


@Component({
  standalone: false,
  selector: 'xform-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {

  constructor(
      public authenticationService: AuthenticationService,
      private jqueryCommonService: JqueryCommonService,
  ) {
  }

}
